export default (num) => {
  // return num.toFixed(2);

  // Fix for occasional rounding errors
  if (num > 0) return (num + 0.0000000000006).toFixed(2);
  if (num < 0) return (num - 0.0000000000006).toFixed(2);
  return num.toFixed(2);
};
